import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "dt_left" }
const _hoisted_10 = { class: "no-style" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "sett-small-menu align-right" }
const _hoisted_13 = { class: "discl-menu dropdown" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_15 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_EmailSettingsModal = _resolveComponent("EmailSettingsModal")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fa', 'fa-spinner'],
          class: "fs-1"
        })
      ]))
    : (_openBlock(), _createElementBlock("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-envelope'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.language.emails_setts), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs",
                disabled: _ctx.listOfEmailSetts.length == 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printListItems()))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'print'] }),
                _createTextVNode("  " + _toDisplayString(_ctx.language.print), 1)
              ], 8, _hoisted_6),
              _createTextVNode("  "),
              _createElementVNode("button", {
                type: "button",
                class: "btn-xs",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshData && _ctx.refreshData(...args)))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'refresh'] }),
                _createTextVNode("  " + _toDisplayString(_ctx.language.refresh), 1)
              ])
            ]),
            (_ctx.listOfEmailSetts.length>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eltSearchKey) = $event))
                  }, null, 8, _hoisted_8), [
                    [_vModelText, _ctx.eltSearchKey]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("p", null, _toDisplayString(_ctx.language.emails_setts_msg), 1),
        _createElementVNode("dl", null, [
          _createElementVNode("dt", _hoisted_9, _toDisplayString(_ctx.language.email_account), 1),
          _createElementVNode("dd", null, [
            _createElementVNode("ul", _hoisted_10, [
              (!_ctx.listOfEmailSetts.length)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, _toDisplayString(_ctx.language.no_acct_connected), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTaxes, (mEmail) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: mEmail.AccountEmail
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", {
                          class: "dropdown-item py-2 d-inline-block",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.openMyEmailSetts(1, mEmail))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                          _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                        ], 8, _hoisted_16),
                        _createElementVNode("a", {
                          class: "dropdown-item text-danger py-2 d-inline-block",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.deleteOneEmailSett(mEmail))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                          _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                        ], 8, _hoisted_17)
                      ])
                    ])
                  ]),
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-check'] }),
                  _createTextVNode("  " + _toDisplayString(_ctx.language.last_saved) + " \"", 1),
                  _createElementVNode("strong", null, _toDisplayString(mEmail.AccountName), 1),
                  _createTextVNode("\" "),
                  _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatDate(mEmail.CreatedDate, 'dddd MMMM DD, YYYY @ HH:ss')), 1)
                ]))
              }), 128)),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-xs btn-success",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMyEmailSetts(0)))
                }, _toDisplayString(_ctx.language.add_acct), 1)
              ])
            ])
          ])
        ]),
        _hoisted_18,
        (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
          _createVNode(_component_EmailSettingsModal, {
            visible: _ctx.isDialogOpen,
            initialValues: _ctx.dialogRecordData,
            recordStatus: _ctx.dialogRecordStatus,
            onCloseForm: _ctx.onCloseForm
          }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"]),
          _createVNode(_component_printer_dialog, {
            visible: _ctx.isPrintvisible,
            onCloseForm: _ctx.onPrintClose,
            printBaseData: _ctx.printInitialValues,
            extraPrintData: _ctx.printExtraData
          }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"])
        ]))
      ]))
}